"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyDateTimePicker = void 0;

const material_1 = require("@mui/material");

const x_date_pickers_1 = require("@mui/x-date-pickers/");

const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");

const react_1 = __importDefault(require("react"));

const SskyCustomDatePicker_1 = require("../SskyCustomDatePicker/SskyCustomDatePicker");

const SskyDateTimePicker = props => {
  return react_1.default.createElement(x_date_pickers_1.LocalizationProvider, {
    dateAdapter: AdapterMoment_1.AdapterMoment,
    id: props.id
  }, props.variant === "inline" || props.variant === "desktop" ? react_1.default.createElement(x_date_pickers_1.DesktopDateTimePicker, {
    ampm: false,
    mask: props.mask,
    className: props.className,
    value: props.value,
    onChange: props.onChange,
    disabled: props.disabled,
    minDate: props.minDate,
    maxDate: props.maxDate,
    hideTabs: !props.showTabs,
    inputFormat: props.format || SskyCustomDatePicker_1.DEFAULT_DATE_FORMAT,
    renderInput: params => react_1.default.createElement(material_1.TextField, Object.assign({}, params, {
      "data-testid": props.dataTestId || `testId-${props.id}`,
      variant: "standard",
      helperText: props.helperText,
      label: props.label || "",
      error: props.error,
      id: props.id
    }))
  }) : react_1.default.createElement(x_date_pickers_1.DateTimePicker, {
    ampm: false,
    mask: props.mask,
    className: props.className,
    value: props.value,
    onChange: props.onChange,
    disabled: props.disabled,
    label: props.label || "",
    minDate: props.minDate,
    maxDate: props.maxDate,
    hideTabs: !props.showTabs,
    inputFormat: props.format || SskyCustomDatePicker_1.DEFAULT_DATE_FORMAT,
    toolbarPlaceholder: props.placeHolder,
    renderInput: params => react_1.default.createElement(material_1.TextField, Object.assign({
      "data-testid": props.dataTestId || `testId-${props.id}`
    }, params, {
      variant: "standard",
      helperText: props.helperText,
      label: props.label || "",
      error: props.error,
      id: props.id
    }))
  }));
};

exports.SskyDateTimePicker = SskyDateTimePicker;
exports.default = react_1.default.memo(SskyDateTimePicker);